import React from 'react';

export default function DashboardPage() {
  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Admin Dashboard</h1>
      </div>
      <p>
        Welcome to the Gaming Science admin panel. Use the navigation to manage users, games, coupons, and transactions.
      </p>
    </div>
  );
}
